import { getAuthHeaders } from '@/utils/authManager';
import { httpCall } from '../common/util';
import config from "../../app/containers/WorkkardDetail/endpoints";

const ep = config.api.endpoints;

export const publishNote = async (payload) => {
  return httpCall({
      method: "PUT",
      headers: getAuthHeaders(),
      data: payload.data,
      url: `/1.0/note/${payload.module}/publish/${payload.note_id}`
  });
    // var options = {
    //     method: 'PUT',
    //     url: `${oapi}note/${payload.module}/publish/${payload.note_id}`,
    //     headers: {
    //         [orgHeader]: org_id,
    //     },
    //     data: payload.data
    // };
    // return publicApiCall(options);
   
}

// To add note on workkard 
export const addNote = async (payload) => {
  return httpCall({
      method: "PUT",
      headers: Object.assign({}, getAuthHeaders(), payload.headers),
      data: payload.data,
      url: `/1.0/${payload.module}/add_note/${payload.moduleId}`
  });
        // var options = {
        //     method: 'PUT',
        //     url: `${oapi}${payload.module}/add_note/${payload.moduleId}`,
        //     data: payload.data,
        //     headers: { ...payload.headers, 
        //         [orgHeader]: org_id,
        //     },
        // };
        // return publicApiCall(options);
}

// for fetching the activityFilters of workkard
export const GetActivityNoteFilters = async (payload) => {
    let origin = payload.view ? payload.view : window.location.href.includes("combined")?"cv":"detail";
    return httpCall({
        method: "GET",
        headers: getAuthHeaders(),
        url: `/1.0/note/filter/${payload.cId}?view-page=${origin}`
    });
}
// To update filter
export const updateActivityNoteFilters = async (payload) => {
  let origin = window.location.href.includes("combined") ? "cv" : "detail";
  return httpCall({
      method: "PUT",
      headers: getAuthHeaders(),
      data: payload.data,
      url: `/1.0/note/filter?view-page=${origin}`
  });
}

export const fetchWorkkardActNoteFiles = async(payload) => {
    const {url, method} = ep.fetchWorkkardActNoteFiles;
    return httpCall({
        method: method,
        headers: getAuthHeaders(),
        url: `${url}?type=All&cId=${payload.cId}&actId=${payload.actId}`
    });
}